import React from 'react';
import { TbStar, TbStarFilled } from 'react-icons/tb';
import { VIEW_MODE_IMAGE_GALLERY } from '../../Utils/Constants/Product';
import ScrollSpy from 'react-scrollspy-navigation';
import { useLayoutContext } from '../../Contexts/LayoutContext';

interface MenuCategoriesProps {
    categories: any;
    currentSwiperSlide: number,
    selectedItemRef: any,
    onHandleClick: CallableFunction,
    loading: boolean,
}

const MenuCategories = ({categories, currentSwiperSlide, selectedItemRef, onHandleClick, loading }: MenuCategoriesProps) => {

    const { isMobile } = useLayoutContext();

    return (
        <div id="boxMenuCategory" className="flex sticky z-20 justify-center gap-2 items-center h-14 min-w-full max-w-full top-20 bg-gradient-to-b from-white to-white/65 backdrop-blur-sm py-2 -mt-3 md:mb-6">
            <div className='w-4/5 flex-1 flex items-center overflow-x-auto no-scrollbar hide-scrollbar py-1 space-x-2'>
                <ScrollSpy offsetTop={isMobile ? 130 : 140}>
                    {categories.map((category: any, index: number) => 
                        <a 
                            href={`#category_${category.id ?? 'featured'}`} 
                            onClick={(e) => { e.preventDefault(); onHandleClick(index, category); }}
                            key={category.id} 
                            ref={currentSwiperSlide === index ? selectedItemRef : null}
                            className={`
                                h-full items-center
                                cursor-pointer md:text-base
                                transition-all ease-in-out
                                font-bold
                                ${category.name && category.name.length > 35 ? 'break-normal min-w-max text-sm text-center' : 'whitespace-nowrap'}
                                ${loading 
                                    ? 'text-shopfood-title'
                                    : currentSwiperSlide === index ? 'text-custom-primary' : 'text-shopfood-title'}
                                `}
                            >
                                {loading ? (
                                        <div className="flex w-32 h-4 bg-gray-200 rounded-full animate-pulse" />
                                    ) : (
                                        <div className={`flex items-center gap-1 px-2 h-9 leading-none break-normal max-w-[90vw]
                                            ${category.name && category.name.length > 35 ? 'py-0.5' : 'py-2'}
                                        `}>
                                            <span>{ category.name }</span>
                                            {(category.layout === VIEW_MODE_IMAGE_GALLERY || category.id === null || category.id === undefined) && (
                                                currentSwiperSlide === index
                                                ? <span><TbStarFilled className="zoomInIconNoDelay" /></span>
                                                : <span><TbStar /></span>
                                            )}
                                        </div>
                                )}
                                <div className={`h-1 rounded-full m-auto transition-all duration-400 delay-200 ease-in-out ${!loading && currentSwiperSlide === index ? 'bg-custom-primary w-full' : 'bg-transparent w-0'}`}></div>
                        </a>
                    )}
                </ScrollSpy>
                
            </div>
        </div>
    )
}

export default MenuCategories;